import React from 'react';
import { Grid, Assets } from '@dewise-devex/backstage-plugin-mui-uikit-react';
import Greeting from '../greeting/Greeting';

import Clock from '../clock/Clock';
import { ClockConfig } from '@backstage/plugin-home';

const clockConfigDK: ClockConfig[] = [
  {
    label: 'CEST/GMT+2',
    timeZone: 'Europe/Paris',
  },
];

const clockConfigPH: ClockConfig[] = [
  {
    label: 'PST/GMT+8',
    timeZone: 'Asia/Singapore',
  },
];

const timeFormat: Intl.DateTimeFormatOptions = {
  hour: '2-digit',
  minute: '2-digit',
  hour12: false,
};

export const HomeHeader = () => {
  return (
    <>
      <Grid size={{ sm: 12, xs: 12, md: 5 }}>
        <Greeting />
      </Grid>
      <Grid
        container
        justifyContent="flex-end"
        spacing={2}
        alignSelf="center"
        size={{ sm: 12, xs: 12, md: 7 }}
      >
        <Grid size={{ sm: 12, xs: 12, md: 6 }}>
          <Clock
            img={Assets.flagPh}
            title="Time in PH"
            clockConfigs={clockConfigPH}
            customTimeFormat={timeFormat}
          />
        </Grid>
        <Grid
          size={{
            sm: 12,
            xs: 12,
            md: 6,
          }}
        >
          <Clock
            img={Assets.flagDk}
            title="Time in DK"
            clockConfigs={clockConfigDK}
            customTimeFormat={timeFormat}
          />
        </Grid>
      </Grid>
    </>
  );
};
